var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"couplet",class:_vm.coupletClasses},[_c('div',{staticClass:"dom"},[_vm._t("dom",[_vm._v(_vm._s(_vm.dom))])],2),_c('div',{staticClass:"sub"},[_vm._t("sub",[_vm._v(_vm._s(_vm.sub))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }